export class BladSamoobslugi extends Error {

  constructor(message: string) {
    super(message)
  }
}
